const contactCards = [
  {
    icon: "ri-customer-service-2-line",
    title: "在线客服",
    desc: "工作时间内真人客服即时响应",
    accent: "bg-primary-500",
    cta: "开始咨询",
  },
  {
    icon: "ri-time-line",
    title: "服务时间",
    desc: "每日 9:00 – 21:00，全年无休",
    accent: "bg-accent-500",
    cta: "查看排班",
  },
  {
    icon: "ri-mail-send-line",
    title: "客服邮箱",
    desc: "service@yy-support.example.com",
    accent: "bg-secondary-500",
    cta: "发送邮件",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="relative bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-secondary-400">
            <i className="ri-contacts-book-line" aria-hidden="true"></i>
            联系我们
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-50">随时随地，我们都愿意倾听</h2>
          <p className="mx-auto mt-4 max-w-2xl text-foreground-300">
            无论是使用疑问、功能建议还是意见反馈，都欢迎随时联系歪歪团队，我们会认真对待每一条声音。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {contactCards.map((c) => (
            <article
              key={c.title}
              className="flex flex-col items-center rounded-xl border border-background-200/70 bg-background-50 p-6 text-center"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${c.accent} text-background-950`}>
                <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base text-foreground-50">{c.title}</h3>
              <p className="mt-1 text-sm text-foreground-400">{c.desc}</p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-300 hover:text-primary-200 transition-colors whitespace-nowrap"
              >
                {c.cta}
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}